import { getStore as getCLPStore, CLPLabel } from 'owa-mail-clp-store/lib/store/store';

export default function(): CLPLabel {
    const { userLabels } = getCLPStore();
    for (let i = 0; i < userLabels.length; i++) {
        if (userLabels[i].isDefault) {
            return userLabels[i];
        }
    }
    return null;
}
